import { ColDef } from "ag-grid-community";
import { useEffect, useState } from "react";
import axiosInstance from "../../axios/axios";
import AgGridTable from "../../components/table/AgGridTable";
import Exclamation from "../../assets/Exclamation.png";
import True_img from "../../assets/baseVersion/True_img.svg";
import Not_Applicable from "../../assets/baseVersion/NotApplicable.svg";
import False_img from "../../assets/baseVersion/False_img.svg";
import Cisco_img from "../../assets/baseVersion/cisco.svg";
import Paloalto_img from "../../assets/baseVersion/paloalto.svg";
import Paloalto_dark from "../../assets/palaoto_dark.svg";
import arista_img from "../../assets/baseVersion/arista.svg";
import arista_dark from "../../assets/arista_dark.svg";

import AWS_img from "../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../assets/baseVersion/AWS_DARK.svg"
import { Tooltip, Typography, useTheme } from "@mui/material";
import juniper_assets from "../../assets/juniper.svg";
import juniper_dark from "../../assets/baseVersion/dark_juniper.svg";
import fortinet_img from "../../assets/fortinet.svg";
import fortinet_scan_dark from "../../assets/fortinet-white-1.svg";
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg"
import sophosLogo from "../../assets/sophos.svg";
import sophos_dark from "../../assets/sophos-white.svg";
import Windows_light from "../../assets/baseVersion/Windows_light.svg";
import Windows_dark from "../../assets/baseVersion/Windows_dark.svg";
import ubuntu from "../../assets/ubuntu.svg";
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../assets/ubuntu_white.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";

import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
interface AssetsFlyoutProps {
  id: string;
  onRowClick?: (row: any) => void;
  module?: string;
  onDataFetched?: (data: any[]) => void;  // optional callback
  parameterType?: string;
}

const AssetsFlyout = ({ id, onRowClick, module, onDataFetched, parameterType }: AssetsFlyoutProps) => {
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [assetsData, setAssetsData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  // let moduleValue = module || "";
  console.log("moduleValue", module)

  // if (!moduleValue) {
  //   if (location.pathname == "/on-premises/security-posture") {
  //     moduleValue = "on_premise";
  //   } else {
  //     moduleValue = "cloud";
  //   }
  // }

  useEffect(() => {
    const fetchAssets = async () => {
      if (!id) return;

      setIsLoading(true);
      setIsReady(false);
      console.log(module, "module")
      try {
        const response = await axiosInstance.get(
          `securityscan/assets?module=${module}&parameter_name_id=${id}`
        );

        if (response.data?.data) {
          const formattedAssets = response.data.data.map((asset: any) => ({
            id: asset.device_id, // Use device_id as the id for navigation
            hostname: asset.host_name,
            vendor: asset.vendor,
            model: asset.device_model,
            compliance:
              asset.compliance === 1 || asset.compliance === "1"
                ? "pass"
                : asset.compliance === 0 || asset.compliance === "0"
                  ? "fail"
                  : asset.compliance === 2 || asset.compliance === "2" || asset.compliance === 3 || asset.compliance === "3"
                    ? "not applicable"
                    : asset.compliance,
            acceptedRisk: asset.accepted_risk,
            device_id: asset.device_id,
            account_id: asset.account_id,
            resources_type: asset.resources_type,
          }));

          setAssetsData(formattedAssets);
          if (formattedAssets.length > 0) {
            setIsReady(true);
          }
          if (onDataFetched) {
            onDataFetched(formattedAssets);
          }
        }
      } catch (error) {
        console.error("Error fetching assets data:", error);
        setAssetsData([]);
        if (onDataFetched) onDataFetched([]); // also notify parent on error

      } finally {
        setIsLoading(false);
      }
    };

    fetchAssets();
  }, [id]);

  // Reset isReady when dependencies change
  useEffect(() => {
    setIsReady(false);
  }, [id]);

  const columnDefs: ColDef[] = [
    {
      field: "vendor",
      headerName: module == "on_premise" ? "Vendor" : "Resource Type",

      filter: true,
      minWidth: 180,
      width: 250,
      cellRenderer: (params: any) => {
        const value = params.value?.toLowerCase();
        let imgSrc = "";

        if (value === "cisco") {
          imgSrc = Cisco_img;
        } else if (
          value?.toLowerCase() === "palo alto" ||
          value?.toLowerCase() === "paloalto"
        ) {
          imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
        } else if (value === "amazon web services") {
          imgSrc = isDarkMode ? AWS_DARK : AWS_img;
        } else if (value === "arista") {
          imgSrc = isDarkMode ? arista_dark : arista_img;
        } else if (value === "juniper") {
          imgSrc = isDarkMode ? juniper_dark : juniper_assets;
        }
        else if (value === "fortinet") {
          imgSrc = isDarkMode ? fortinet_scan_dark : fortinet_img;
        }
        else if (value === "sophos") {
          imgSrc = isDarkMode ? sophos_dark : sophosLogo;
        } else if (value === "ubuntu") {
          imgSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
        }
        else if (value === "microsoft") {
          imgSrc = isDarkMode ? Windows_dark : Windows_light;
        } else if (value === "debian") {
          imgSrc = isDarkMode ? debian_dark : debian;
        } else if (value === "redhat") {
          imgSrc = isDarkMode ? redhat_dark : redhat_light;
        } else if (value === "huawei") {
          imgSrc = isDarkMode ? huawei_dark : huawei_light;
        } else if (value === "mikrotik") {
          imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
        } else if (value === "edgecore") {
          imgSrc = edgecore_logo;
        } else if (value === "tp-link" || value === "tplink") {
          imgSrc = isDarkMode ? tplink_dark : tplink_light;
        } else if (value === "apple" || value === "macos") {
          imgSrc = isDarkMode ? apple_dark : apple_img;
        } else if (value === "dell") {
          imgSrc = dell_logo;
        } else if (value === "syrotech") {
          imgSrc = isDarkMode ? syrotech_dark : syrotech_light;
        }

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {imgSrc && (
              params?.value?.toLowerCase() === "dell" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 40, height: 40, objectFit: "contain", marginRight: 8 }}
                />
              ) : params?.value?.toLowerCase() === "syrotech" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 90, height: 32, objectFit: "contain", marginRight: 8 }}
                />
              ) : params?.value?.toLowerCase() === "huawei" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 80, height: 30, objectFit: "contain", marginRight: 8 }}
                />
              ) : params?.value?.toLowerCase() === "edgecore" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 80, height: 30, objectFit: "contain", marginRight: 8, filter: isDarkMode ? "brightness(0) invert(1)" : "none" }}
                />
              ) : params?.value?.toLowerCase() === "tp-link" || params?.value?.toLowerCase() === "tplink" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 80, height: 30, objectFit: "contain", marginRight: 8 }}
                />
              ) : params?.value === "arista" || params?.value === "palo alto" || params?.value === "sophos" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ height: 10, marginRight: 8, marginTop: 8 }}
                />
              ) : (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ height: 20, marginRight: 8, marginTop: 8 }}
                />
              )
            )}
            {module !== "on_premise" && params.data.resources_type}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: module === "on_premise" ? "model" : "account_id",
      headerName: module === "on_premise" ? "OS" : "Account",
      filter: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: (params: any) => (
        <Tooltip
          title={params.value || ""}
          slotProps={{
            popper: {
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: "#fff",
                  color: "#000",
                  fontSize: "0.85rem",
                  border: "1px solid #ddd",
                  boxShadow: 2,
                },
              },
            },
          }}
        >
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "hostname",
      headerName: "Host Name",
      filter: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: (params: any) => (
        <Tooltip
          title={params.value || ""}
          slotProps={{
            popper: {
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: "#fff",
                  color: "#000",
                  fontSize: "0.85rem",
                  border: "1px solid #ddd",
                  boxShadow: 2,
                },
              },
            },
          }}
        >
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "acceptedRisk",
      headerName: "Accepted Risk",
      filter: true,
      minWidth: 100,
      width: 100,
      cellRenderer: (params: any) => {
        if (isTemplate) {
          return (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              N/A
            </Typography>
          );
        }
        if (params.value === true) {
          return (
            <img
              src={Exclamation}
              alt="Not Accepted"
              style={{ width: 20, height: 20 }}
            />
          );
        }
        return (
          <img
            src={AcceptedRisk_False}
            alt="Accepted"
            style={{ width: 20, height: 20 }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "compliance",
      headerName: "Compliance",
      filter: true,
      minWidth: 120,
      cellRenderer: (params: any) => {
        let imgSrc;
        let altText;

        switch (params.value) {
          case "pass":
          case 1:
          case "1":
            imgSrc = True_img;
            altText = "Pass";
            break;
          case "fail":
          case 0:
          case "0":
            imgSrc = False_img;
            altText = "Fail";
            break;
          case "not applicable":
          case "manual":
          case 2:
          case "2":
          case 3:
          case "3":
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
            break;
          default:
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
        }

        return (
          <img
            src={imgSrc}
            alt={altText}
            style={{ width: 20, height: 20 }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  ];

  return (
    // <div
    //   style={{
    //     height: "calc(90vh - 95px)",
    //     display: "flex",
    //     flexDirection: "column",
    //     overflow: "auto",
    //     scrollbarWidth: "none",
    //   }}
    // >
    <AgGridTable
      columnDefs={columnDefs}
      data={assetsData}
      showSearch
      isRowSelectable
      height={"calc(100vh - 192px)"}
      onRowClick={(row: any) => {
        if (onRowClick) onRowClick(row);
      }}
      isLoading={!isReady || isLoading}
    />
    // </div>
  );
};

export default AssetsFlyout;
